import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `gitlab_ci`,

  name: {
    [LOCALES.EN_US]: `GitLab CI`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.service, TYPES.tool],

  tags: [],
} as const satisfies TTerm
